import { render, staticRenderFns } from "./OrbitLeaderboardPagination.vue?vue&type=template&id=0a555caf&scoped=true"
import script from "./OrbitLeaderboardPagination.vue?vue&type=script&lang=ts"
export * from "./OrbitLeaderboardPagination.vue?vue&type=script&lang=ts"
import style0 from "./OrbitLeaderboardPagination.vue?vue&type=style&index=0&id=0a555caf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a555caf",
  null
  
)

export default component.exports